import { EyeIcon, ForbiddenIcon } from '@src/svg';
import { Column } from '@uikit/Tables/types';
import React from 'react';
import { TooltipWrapper } from '@uikit/TooltipWrapper';

// the Validity pill of the credentialing record tables ("Expiring Soon" …),
// "—" while a record is still valid. The custom table hands renderCell the row
// itself, not { row }
const credentialingValidityColumn: Column = {
  field: 'validity',
  headerName: 'Validity',
  type: 'string',
  flex: 1,
  isFilterable: false,
  isSortable: false,
  isLocked: false,
  renderCell: (row: any) =>
    row?.validity ? (
      <span
        className={`credentialing__badge credentialing__badge--${row.validity
          .toLowerCase()
          .replace(/\s+/g, '-')}`}
      >
        {row.validity}
      </span>
    ) : (
      '—'
    ),
};

// TODO: no payer approval endpoint yet, the rows carry "—"
const credentialingApprovalColumn: Column = {
  field: 'approval',
  headerName: 'Approval',
  type: 'string',
  flex: 1,
  isFilterable: false,
  isSortable: false,
  isLocked: false,
};

// the "…" menu of a credentialing record row, Edit only
const credentialingRowMenuColumn: Column = {
  field: '',
  headerName: '',
  type: 'buttons',
  buttons: {
    view: false,
    edit: true,
    audit: false,
  },
  width: 30,
  isSortable: false,
  className: 'table_buttons_styles',
  isFilterable: false,
  isLocked: true,
};

export const TABLE_COLUMNS = {
  payorRatesColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'lob',
      headerName: 'LOB',
      type: 'string',
      className: 'lob_styles',
      isFilterable: true,
      sortingField: 'lob',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'modeOfTransport',
      headerName: 'Mode',
      type: 'string',
      className: 'modeOfTransport_styles',
      isFilterable: true,
      sortingField: 'modeOfTransport',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'equipmentAndAddon',
      headerName: 'Addon',
      type: 'string',
      className: 'addon_styles',
      isFilterable: true,
      sortingField: 'equipmentAndAddon',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'hcpcOrBillingCode',
      headerName: 'Billing Code',
      type: 'string',
      className: 'billing_styles',
      isFilterable: true,
      sortingField: 'hcpcOrBillingCode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketStartUnits',
      headerName: 'Unit Start',
      type: 'string',
      className: 'unitStart_styles',
      isFilterable: true,
      sortingField: 'bucketStartUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketEndUnits',
      headerName: 'Unit End',
      type: 'string',
      className: 'unitEnd_styles',
      isFilterable: true,
      sortingField: 'bucketEndUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketFreeUnits',
      headerName: 'Free Units',
      type: 'string',
      className: 'freeUnits_styles',
      isFilterable: true,
      sortingField: 'bucketFreeUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'baseRate',
      headerName: 'Base Rate',
      type: 'string',
      className: 'baseRate_styles',
      isFilterable: true,
      sortingField: 'baseRate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'unitRate',
      headerName: 'Unit Rate',
      type: 'string',
      className: 'unitRate_styles',
      isFilterable: true,
      sortingField: 'unitRate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'billQualifierType',
      headerName: 'Billing Qualifier',
      type: 'string',
      className: 'billQualifierType_styles',
      isFilterable: true,
      sortingField: 'billQualifierType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'markUpType',
      headerName: 'Mark-up Type',
      type: 'string',
      isFilterable: true,
      sortingField: 'markUpType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'markUpValue',
      headerName: 'Mark-up',
      type: 'string',
      className: 'markUpType_styles',
      isFilterable: true,
      sortingField: 'markUpValue',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  payorModeOfTransportColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'Type',
      isFilterable: false,
      sortingField: 'type',
      isSortable: false,
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isLocked: false,
    },
    {
      field: 'lob',
      headerName: 'LOB',
      filterKey: 'lobId',
      filterType: 'select',
      filterSelectName: 'lob',
      isFilterable: true,
      sortingField: 'lobId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'lob_styles',
      isLocked: false,
    },
    {
      field: 'modeOfTransport',
      headerName: 'Level of Service',
      filterKey: 'modeOfTransportId',
      filterType: 'select',
      filterSelectName: 'payerMot',
      isFilterable: true,
      sortingField: 'modeOfTransportId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'modeOfTransport_styles',
      isLocked: false,
    },
    {
      field: 'loadDuration',
      headerName: 'Load Duration',
      filterKey: 'loadDuration',
      filterType: 'time',
      isFilterable: true,
      sortingField: 'loadDuration',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'loadDuration_styles',
      isLocked: false,
    },
    {
      field: 'unloadDuration',
      headerName: 'Unload Duration',
      filterKey: 'unloadDuration',
      filterType: 'time',
      isFilterable: true,
      sortingField: 'unloadDuration',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'unloadDuration_styles',
      isLocked: false,
    },
    {
      field: 'authRequired',
      headerName: 'Auth Required?',
      filterKey: 'authRequired',
      filterType: 'boolean',
      filterOptions: [
        { id: 1, value: true, label: 'yes' },
        { id: 2, value: false, label: 'no' },
      ],
      isFilterable: true,
      sortingField: 'authRequired',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'authRequired_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  modeOfTransportColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'modeOfTransportType',
      headerName: 'Type',
      filterKey: 'type_id',
      isFilterable: true,
      sortingField: 'modeOfTransportTypeId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'type_styles',
      filterType: 'select',
      isLocked: false,
    },
    {
      field: 'modeOfTransportCategory',
      headerName: 'Level of Service',
      // filterKey: 'modeOfTransportCategoryId',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'contractorMot',
      isFilterable: true,
      // sortingField: 'modeOfTransportCategoryId',
      sortingField: 'categoryId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'modeOfTransport_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  contractorRatesColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'modeOfTransport',
      headerName: 'Mode',
      type: 'string',
      className: 'modeOfTransport_styles',
      isFilterable: true,
      sortingField: 'modeOfTransport',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'equipmentAndAddon',
      headerName: 'Addon',
      type: 'string',
      className: 'addon_styles',
      isFilterable: true,
      sortingField: 'equipmentAndAddon',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'hcpcOrBillingCode',
      headerName: 'Billing Code',
      type: 'string',
      className: 'billing_styles',
      isFilterable: true,
      sortingField: 'hcpcOrBillingCode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketStartUnits',
      headerName: 'Unit Start',
      type: 'string',
      className: 'unitStart_styles',
      isFilterable: true,
      sortingField: 'bucketStartUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketEndUnits',
      headerName: 'Unit End',
      type: 'string',
      className: 'unitEnd_styles',
      isFilterable: true,
      sortingField: 'bucketEndUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'bucketFreeUnits',
      headerName: 'Free Units',
      type: 'string',
      className: 'freeUnits_styles',
      isFilterable: true,
      sortingField: 'bucketFreeUnits',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'baseRate',
      headerName: 'Base Rate',
      type: 'string',
      className: 'baseRate_styles',
      isFilterable: true,
      sortingField: 'baseRate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'unitRate',
      headerName: 'Unit Rate',
      type: 'string',
      className: 'unitRate_styles',
      isFilterable: true,
      sortingField: 'unitRate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'billQualifierType',
      headerName: 'Billing Qualifier',
      type: 'string',
      className: 'billQualifierType_styles',
      isFilterable: true,
      sortingField: 'billQualifierType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  contractsAgreementsColumns: [
    {
      field: 'executionDate',
      headerName: 'Execution',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'executionDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'Contract Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'shortNotes',
      headerName: 'Short note',
      type: 'string',
      flex: 1,
      className: 'shortNotes_styles',
      isFilterable: true,
      sortingField: 'shortNotes',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  factoringAgreementColumns: [
    {
      field: 'executionDate',
      headerName: 'Execution',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'executionDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'rate',
      headerName: 'Factoring rate',
      type: 'string',
      className: 'rate_styles',
      isFilterable: true,
      sortingField: 'rate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'shortNotes',
      headerName: 'Short note',
      type: 'string',
      className: 'shortNotes_styles',
      isFilterable: true,
      sortingField: 'shortNotes',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  assignmentTableColumns: [
    {
      field: 'contractor',
      headerName: 'Contractor',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'contractor',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'member',
      headerName: 'Member',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'member',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'service',
      headerName: 'Rendering Service',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'service',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpTime',
      headerName: 'PU Time',
      type: 'string',
      width: '7%',
      isFilterable: true,
      sortingField: 'pickUpTime',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpCounty',
      headerName: 'PU County',
      type: 'string',
      width: '13%',
      isFilterable: true,
      sortingField: 'pickUpCounty',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpCityZipcode',
      headerName: 'PU City, Zip',
      type: 'string',
      width: '13%',
      isFilterable: true,
      sortingField: 'pickUpCityZipcode',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'dropOfCityZipcode',
      headerName: 'DO City, Zip',
      type: 'string',
      width: '13%',
      isFilterable: true,
      sortingField: 'dropOfCityZipcode',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'miles',
      headerName: 'Miles',
      type: 'string',
      width: '7%',
      isFilterable: true,
      sortingField: 'miles',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'duration',
      headerName: 'Duration',
      type: 'string',
      width: '7%',
      isFilterable: true,
      sortingField: 'duration',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'los',
      headerName: 'LOS',
      type: 'string',
      width: '12%',
      isFilterable: true,
      sortingField: 'los',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'statusId',
      headerName: 'Ride Status',
      type: 'flag',
      width: '18%',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'ride',
      headerName: 'Ride ID',
      type: 'string',
      width: '9%',
      isFilterable: true,
      sortingField: 'rideId',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'standingOrder',
      headerName: 'ST',
      type: 'disabledRadio',
      width: 25,
      isFilterable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'dos',
      headerName: 'Date of Service',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'dos',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'renderingServiceCategory',
      headerName: 'Rendering Service Category',
      type: 'string',
      width: '9%',
      isFilterable: true,
      sortingField: 'renderingServiceCategory',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'pickUpAddress',
      headerName: 'Pickup Address',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'pickUpAddress',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'dropOffAddress',
      headerName: 'Drop-Off Address',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'dropOffAddress',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'dropOffCounty',
      headerName: 'Drop-Off County',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'dropOffCounty',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'willCallIndicator',
      headerName: 'Will Call Indicator',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'willCallIndicator',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'statusGroup',
      headerName: 'Status Group',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'statusGroup',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'cost',
      headerName: 'Cost',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'cost',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualMiles',
      headerName: 'Actual Miles',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'actualMiles',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualPickUpArriveTime',
      headerName: 'Pickup Arrive',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'actualPickUpArriveTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualPickUpDepartTime',
      headerName: 'Pickup Depart',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'actualPickUpDepartTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualDropOffArriveTime',
      headerName: 'Drop-Off Arrive',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'actualDropOffArriveTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualDropOffDepartTime',
      headerName: 'Drop-Off Depart',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'actualDropOffDepartTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'onTimeStatus',
      headerName: 'On Time Status',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'onTimeStatus',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'memberId',
      headerName: 'Member ID',
      type: 'string',
      width: '11%',
      isFilterable: true,
      sortingField: 'memberId',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 40,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
    },
  ],
  auditLogsColumns: [
    {
      field: 'field',
      headerName: 'Field',
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'field',
      isSortable: true,
      flex: 1,
      className: 'field_styles',
      isLocked: false,
    },
    // {
    //   field: 'message',
    //   headerName: 'Message',
    //   filterKey: 'message',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'message',
    //   isSortable: true,
    //   flex: 1,
    //   className: 'newValue_styles',
    //   isLocked: false,
    // },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'beforeChange',
      isSortable: true,
      flex: 1,
      className: 'originalValue_styles',
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'afterChange',
      isSortable: true,
      flex: 1,
      className: 'newValue_styles',
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'Changed By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'changedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'changedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'orderingValue',
      headerName: 'Segment Number',
      filterKey: 'orderingValue',
      filterType: 'localSelect',
      isFilterable: true,
      sortingField: 'orderingValue',
      isSortable: true,
      flex: 1,
      filterOptions: [],
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  recordViewColumns: [
    {
      field: 'ipAddress',
      headerName: 'IP Address',
      type: 'string',
      filterKey: 'ipAddress',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'ipAddress',
      isSortable: true,
      flex: 1,
      className: 'ipAddress_styles',
      isLocked: false,
    },
    {
      field: 'address',
      headerName: 'Location',
      type: 'clickableString',
      filterKey: 'address',
      // filterKey: 'city',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'address',
      // sortingField: 'city',
      isSortable: true,
      flex: 1,
      className: 'location_styles',
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'Viewed By',
      type: 'string',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'viewedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'viewedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'timestamp',
      headerName: 'Time',
      type: 'string',
      filterKey: 'timestamp',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'timestamp',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  limitationsColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'limitType',
      headerName: 'Limit Type',
      filterKey: 'limitTypeId',
      filterType: 'select',
      isFilterable: false,
      sortingField: 'limitTypeId',
      isSortable: false,
      type: 'string',
      flex: 1,
      className: 'limitType_styles',
      isLocked: false,
    },
    {
      field: 'lineOfBusiness',
      headerName: 'Line of Business',
      filterKey: 'lineOfBusinessId',
      filterType: 'select',
      filterSelectName: 'lob',
      isFilterable: false, // can be true after back ready
      sortingField: 'lineOfBusinessId',
      isSortable: false, // can be true after back ready
      type: 'string',
      flex: 1,
      className: 'lineOfBusiness_styles',
      isLocked: false,
    },
    {
      field: 'unitsAllowed',
      headerName: 'Allowed',
      filterKey: 'unitsAllowed',
      filterType: 'number',
      isFilterable: true,
      sortingField: 'unitsAllowed',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'allowed_styles',
      isLocked: false,
    },
    {
      field: 'unitsUsed',
      headerName: 'Used',
      filterKey: 'unitsUsed',
      filterType: 'number',
      isFilterable: true,
      sortingField: 'unitsUsed',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'used_styles',
      isLocked: false,
    },
    {
      field: 'unitsRemaining',
      headerName: 'Remaining',
      filterKey: 'unitsRemaining',
      filterType: 'number',
      isFilterable: false,
      sortingField: 'unitsRemaining',
      isSortable: false,
      type: 'string',
      flex: 1,
      className: 'remain_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  serviceAuthorizationsColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'healthPlan',
      headerName: 'Health Plan',
      filterKey: 'healthPlanId',
      filterType: 'select',
      filterSelectName: 'healthPlan',
      isFilterable: true,
      sortingField: 'healthPlanId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'healthPlan_styles',
      isLocked: false,
    },
    {
      field: 'modeOfTransport',
      headerName: 'Level of Service',
      filterKey: 'losId',
      filterType: 'select',
      filterSelectName: 'memberMot',
      isFilterable: true,
      sortingField: 'modeOfTransportId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'modeOfTransport_styles',
      isLocked: false,
    },
    {
      field: 'authorizationNumber',
      headerName: 'Auth Number',
      filterKey: 'authorizationNumber',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'authorizationNumber',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'authNumber_styles',
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      filterKey: 'status',
      filterType: 'boolean',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  eligibilityTransactionsColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'healthPlan',
      headerName: 'Health Plan',
      filterKey: 'healthPlanId',
      filterType: 'select',
      filterSelectName: 'healthPlan',
      isFilterable: true,
      sortingField: 'healthPlanId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'healthPlan_styles',
      isLocked: false,
    },
    {
      field: 'lineOfBusiness',
      headerName: 'Line of Business',
      filterKey: 'lineOfBusinessId',
      filterType: 'select',
      filterSelectName: 'lob',
      isFilterable: true,
      sortingField: 'lineOfBusinessId',
      isSortable: true,
      flex: 1,
      className: 'lineOfBusiness_styles',
      isLocked: false,
    },
    {
      field: 'planCode',
      headerName: 'Plan Code',
      filterKey: 'planCode',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'planCode',
      isSortable: true,
      flex: 1,
      className: 'planCode_styles',
      isLocked: false,
    },
    {
      field: 'importedDate',
      headerName: 'Imported/Created',
      flex: 1,
      className: 'importedDate_styles',
      isFilterable: false,
      sortingField: 'importedDate',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'fileName',
      headerName: 'Import File',
      flex: 1,
      className: 'fileName_styles',
      isFilterable: false,
      sortingField: 'fileName',
      isSortable: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  liabilityTableColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'insuranceInsurer',
      headerName: 'Insurer',
      type: 'string',
      flex: 1,
      className: 'insuranceInsurer_styles',
      isFilterable: true,
      sortingField: 'insuranceInsurer',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'insuranceType',
      headerName: 'Insurance Type',
      type: 'string',
      flex: 1,
      className: 'insuranceType_styles',
      isFilterable: true,
      sortingField: 'insuranceType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'number',
      headerName: 'Policy Number',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'limitAggregate',
      headerName: 'Aggregate',
      type: 'string',
      flex: 1,
      className: 'limitAggregate_styles',
      isFilterable: true,
      sortingField: 'limitAggregate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'limitOccurrence',
      headerName: 'Per Occurrence',
      type: 'boolean',
      flex: 1,
      className: 'limitOccurrence_styles',
      isFilterable: true,
      sortingField: 'limitOccurrence',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  vehicleRegistrationTableColumns: [
    {
      field: 'plate',
      headerName: 'Plate',
      type: 'string',
      flex: 1,
      className: 'plate_styles',
      isFilterable: true,
      sortingField: 'plate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'inspectedDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'inspectedDate_styles',
      isFilterable: true,
      sortingField: 'inspectedDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'issuingAuthority',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'issuingAuthority_styles',
      isFilterable: true,
      sortingField: 'issuingAuthority',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'vin',
      headerName: 'VIN',
      type: 'string',
      flex: 1,
      className: 'vin_styles',
      isFilterable: true,
      sortingField: 'vin',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  vehicleInspectionTableColumns: [
    {
      field: 'type',
      headerName: 'Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'inspectedDate',
      headerName: 'Inspected',
      type: 'string',
      flex: 1,
      className: 'inspectedDate_styles',
      isFilterable: true,
      sortingField: 'inspectedDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'inspectionOrganization',
      headerName: 'Inspected by',
      type: 'string',
      flex: 1,
      className: 'inspectionOrganization_styles',
      isFilterable: true,
      sortingField: 'inspectionOrganization',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Determination',
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  vehiclePermitTableColumns: [
    {
      field: 'permitNumber',
      headerName: 'Permit Number',
      type: 'string',
      flex: 1,
      className: 'permitNumber_styles',
      isFilterable: true,
      sortingField: 'permitNumber',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expiration',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expiration',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'issuing',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'issuing_styles',
      isFilterable: true,
      sortingField: 'issuing',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  vehicleServiceDatesTableColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'note',
      headerName: 'Detail',
      type: 'string',
      flex: 1,
      className: 'note_styles',
      isFilterable: true,
      sortingField: 'note',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  physicianCertificationStatementsColumns: [
    {
      field: 'sendingDate',
      headerName: 'Sent',
      type: 'string',
      flex: 1,
      className: 'sent_styles',
      isFilterable: true,
      sortingField: 'sendingDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'sendTo',
      headerName: 'Sent to',
      type: 'string',
      flex: 1,
      className: 'sentTo_styles',
      isFilterable: true,
      sortingField: 'sendTo',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'modeOfTransport',
      headerName: 'Prescribed Mode',
      type: 'string',
      flex: 1,
      className: 'modeOfTransport_styles',
      isFilterable: true,
      sortingField: 'modeOfTransport',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  payorDocsColumns: [
    {
      field: 'documentRecordID',
      headerName: 'Document Record ID',
      type: 'string',
      flex: 1,
      className: 'documentRecordID_styles',
      isFilterable: true,
      sortingField: 'documentRecordID',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'uploadedFileName',
      headerName: 'Uploaded File Name',
      type: 'string',
      flex: 1,
      className: 'uploadedFileName_styles',
      isFilterable: true,
      sortingField: 'uploadedFileName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'created',
      headerName: 'Created',
      type: 'string',
      flex: 1,
      className: 'created_styles',
      isFilterable: true,
      sortingField: 'created',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'uploadedBy',
      headerName: 'Uploaded By',
      type: 'string',
      flex: 1,
      className: 'uploadedBy_styles',
      isFilterable: true,
      sortingField: 'uploadedBy',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      className: 'role_styles',
      isFilterable: true,
      sortingField: 'roleId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  miscColumns: [
    {
      field: 'record_id',
      headerName: 'Document Record ID',
      type: 'string',
      flex: 1,
      className: 'documentRecordID_styles',
      isFilterable: true,
      sortingField: 'record_id',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'fileName',
      headerName: 'Uploaded File Name ',
      type: 'string',
      flex: 1,
      className: 'uploadedFileName_styles',
      isFilterable: true,
      sortingField: 'fileName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'created',
      headerName: 'Created',
      type: 'string',
      flex: 1,
      className: 'created_styles',
      isFilterable: true,
      sortingField: 'created',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'upload_by',
      headerName: 'Uploaded By',
      type: 'string',
      flex: 1,
      className: 'uploadedBy_styles',
      isFilterable: true,
      sortingField: 'upload_by',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      className: 'role_styles',
      isFilterable: true,
      sortingField: 'roleId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 96,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  segmentTransmitColumns: [
    //TODO test this and if it is ok, remove it
    // {
    //   field: 'recordType',
    //   headerName: 'Record Type',
    //   filterKey: 'recordType',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'recordType',
    //   isSortable: true,
    //   className: 'type_styles',
    //   flex: 1,
    //   isChecked: false,
    //   isLocked: false,
    // },
    // {
    //   field: 'transmitType',
    //   headerName: 'Transmit Type',
    //   filterKey: 'transmitType',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'transmitType',
    //   isSortable: true,
    //   className: 'type_styles',
    //   flex: 1,
    //   isChecked: false,
    //   isLocked: false,
    // },
    // {
    //   field: 'fileId',
    //   headerName: 'File ID',
    //   filterKey: 'fileId',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'recordId',
    //   isSortable: true,
    //   flex: 1,
    //   isChecked: true,
    //   isLocked: false,
    // },
    {
      field: 'status',
      headerName: 'Status',
      filterKey: 'status',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      flex: 1,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'error',
      headerName: 'Message',
      filterKey: 'message',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'error',
      isSortable: false,
      flex: 1,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'user',
      headerName: 'Transmit By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'transmitBy',
      isFilterable: false,
      sortingField: 'userId',
      isSortable: false,
      flex: 1,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      // className: 'role_styles',
      flex: 1,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'time',
      headerName: 'Time',
      filterKey: 'time',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      isChecked: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: false,
        audit: false,
      },
      width: 30,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
    },
  ],
  monitoringTransmitColumns: [
    {
      field: 'recordType',
      headerName: 'Record Type',
      filterKey: 'recordType',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'recordType',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Transmit Status',
      filterKey: 'status',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'error',
      headerName: 'Error',
      filterKey: 'error',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'error',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'user',
      headerName: 'Transmitted By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'transmitBy',
      isFilterable: false,
      sortingField: 'userId',
      isSortable: false,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'time',
      headerName: 'Time',
      filterKey: 'time',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'time',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
  ],
  monitoringTableColumns: [
    {
      field: 'member',
      headerName: 'Member',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'member',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'service',
      headerName: 'Rendering Service',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'service',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpTime',
      headerName: 'Pickup Time',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'pickUpTime',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpCounty',
      headerName: 'PU County',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'pickUpCounty',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'pickUpCityZipcode',
      headerName: 'PU City, Zip',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'pickUpCityZipcode',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'dropOfCityZipcode',
      headerName: 'DO City, Zip',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'dropOfCityZipcode',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'miles',
      headerName: 'Miles',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'miles',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'rideOrderConfirmationCode',
      headerName: 'Confirmation Code',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'rideOrderConfirmationCode',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'statusId',
      headerName: 'Rideshare Status',
      type: 'flag',
      flex: 1,
      isFilterable: false,
      sortingField: 'status',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'contractor',
      headerName: 'Contractor',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'contractor',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'memberId',
      headerName: 'Member ID',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'memberId',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'dos',
      headerName: 'Date of Service',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'dos',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'los',
      headerName: 'Level of Service',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'los',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'renderingServiceCategory',
      headerName: 'Rendering Service Category',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'renderingServiceCategory',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'pickUpAddress',
      headerName: 'Pickup Address',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'pickUpAddress',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'dropOffAddress',
      headerName: 'Drop-Off Address',
      type: 'string',
      flex: 1,
      isFilterable: false,
      sortingField: 'dropOffAddress',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'dropOffCounty',
      headerName: 'Drop-Off County',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'dropOffCounty',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'willCallIndicator',
      headerName: 'Will Call Indicator',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'willCallIndicator',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'statusGroup',
      headerName: 'Status Group',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'statusGroup',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'cost',
      headerName: 'Cost',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'cost',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualMiles',
      headerName: 'Actual Miles',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'actualMiles',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'driverAcceptedTime',
      headerName: 'Driver Accepted Time',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'driverAcceptedTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualPickUpArriveTime',
      headerName: 'Actual Pickup Arrive Time',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'actualPickUpArriveTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualPickUpDepartTime',
      headerName: 'Actual Pickup Depart Time',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'actualPickUpDepartTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualDropOffArriveTime',
      headerName: 'Actual Drop-Off Arrive Time',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'actualDropOffArriveTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'actualDropOffDepartTime',
      headerName: 'Actual Drop-Off Depart Time',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'actualDropOffDepartTime',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: 'onTimeStatus',
      headerName: 'On Time Status',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'onTimeStatus',
      isSortable: true,
      isChecked: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
    },
  ],
  notesColumns: [
    {
      field: 'category',
      headerName: 'Note Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'noteCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      flex: 1,
      className: 'noteCategory_styles',
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      filterKey: 'noteDetail',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'noteDetail',
      isSortable: true,
      flex: 1,
      className: 'noteDetail_styles',
      isLocked: false,
    },
    {
      field: 'username',
      headerName: 'Noted by',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'notedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'notedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  notesByContactColumns: [
    {
      field: 'category',
      headerName: 'Note Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'noteCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      flex: 1,
      className: 'noteCategory_styles',
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      filterKey: 'noteDetail',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'noteDetail',
      isSortable: true,
      flex: 1,
      className: 'noteDetail_styles',
      isLocked: false,
    },
    {
      field: 'username',
      headerName: 'Noted by',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'notedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'notedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  notesByAssociatedColumns: [
    {
      field: 'noteCategory',
      headerName: 'Note Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'noteCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      flex: 1,
      className: 'noteCategory_styles',
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      filterKey: 'noteDetail',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'noteDetail',
      isSortable: true,
      flex: 1,
      className: 'noteDetail_styles',
      isLocked: false,
    },
    {
      field: 'username',
      headerName: 'Noted by',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'notedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'notedBy_styles',
      isLocked: false,
    },
    {
      field: 'roleId',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  rideOrStandingOrderNotesColumns: [
    {
      field: 'category',
      headerName: 'Note Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'noteCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      flex: 1,
      className: 'noteCategory_styles',
      isLocked: false,
    },
    {
      field: 'orderingValue',
      headerName: 'Segment Number',
      filterKey: 'orderingValue',
      filterType: 'localSelect',
      isFilterable: true,
      sortingField: 'orderingValue',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      filterKey: 'noteDetail',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'noteDetail',
      isSortable: true,
      flex: 1,
      className: 'noteDetail_styles',
      isLocked: false,
    },
    {
      field: 'username',
      headerName: 'Noted by',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'notedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'notedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  modificationHistoryColumns: [
    {
      field: 'field',
      headerName: 'Field',
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'field',
      isSortable: true,
      flex: 1,
      className: 'field_styles',
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'beforeChange',
      isSortable: true,
      flex: 1,
      className: 'originalValue_styles',
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'afterChange',
      isSortable: true,
      flex: 1,
      className: 'newValue_styles',
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'Changed By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'changedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'changedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    // {
    //   field: 'message',
    //   headerName: 'Message',
    //   filterKey: 'message',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'message',
    //   isSortable: true,
    //   flex: 1,
    //   className: 'newValue_styles',
    //   isLocked: false,
    // },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  rideOrStandingOrderModificationHistoryColumns: [
    {
      field: 'field',
      headerName: 'Field',
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'field',
      isSortable: true,
      flex: 1,
      className: 'field_styles',
      isLocked: false,
    },
    {
      field: 'orderingValue',
      headerName: 'Segment Number',
      filterKey: 'orderingValue',
      filterType: 'localSelect',
      isFilterable: true,
      sortingField: 'orderingValue',
      isSortable: true,
      flex: 1,
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'beforeChange',
      isSortable: true,
      flex: 1,
      className: 'originalValue_styles',
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'afterChange',
      isSortable: true,
      flex: 1,
      className: 'newValue_styles',
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'Changed By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'changedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'changedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    // {
    //   field: 'message',
    //   headerName: 'Message',
    //   filterKey: 'message',
    //   filterType: 'text',
    //   isFilterable: true,
    //   sortingField: 'message',
    //   isSortable: true,
    //   flex: 1,
    //   className: 'newValue_styles',
    //   isLocked: false,
    // },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  exclusionsContractorsTableColumns: [
    {
      field: 'effective',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effective',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expiration',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expiration',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'contractor',
      headerName: 'Contractor',
      type: 'number',
      flex: 1,
      className: 'contractor_styles',
      isFilterable: true,
      sortingField: 'contractor',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'reason',
      headerName: 'Reason',
      type: 'string',
      flex: 1,
      className: 'reason_styles',
      isFilterable: true,
      sortingField: 'reason',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'requester',
      headerName: 'Requester',
      type: 'string',
      flex: 1,
      className: 'requester_styles',
      isFilterable: true,
      sortingField: 'requester',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  payerServicesColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      filterKey: 'effectiveDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      filterKey: 'expirationDate',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'lob',
      headerName: 'LOB  ',
      filterKey: 'lobId',
      filterType: 'select',
      filterSelectName: 'lob',
      isFilterable: true,
      sortingField: 'lobId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'lob_styles',
      isLocked: false,
    },
    {
      field: 'category',
      headerName: 'Service Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'serviceCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'serviceCategory_styles',
      isLocked: false,
    },
    {
      field: 'type',
      // headerName: 'Service Type',
      headerName: 'Rendering Service',
      filterKey: 'type',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'approvedService',
      headerName: 'Covered',
      filterKey: 'approvedService',
      filterType: 'boolean',
      isFilterable: true,
      sortingField: 'approvedService',
      isSortable: true,
      type: 'boolean',
      flex: 1,
      className: 'boolean_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      isFilterable: false,
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isLocked: true,
    },
  ],
  locationAdmittedColumns: [
    {
      field: 'memberId',
      headerName: 'Mbr. ID',
      type: 'string',
      width: 96,
      className: 'memberId_styles',
      isFilterable: true,
      sortingField: 'memberId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'memberName',
      headerName: 'Mbr. Name',
      type: 'string',
      width: 96,
      className: 'memberName_styles',
      isFilterable: true,
      sortingField: 'memberName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'client',
      headerName: 'Client',
      type: 'string',
      width: 96,
      className: 'client_styles',
      isFilterable: true,
      sortingField: 'client',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'admitted',
      headerName: 'Admitted',
      type: 'string',
      width: 145,
      className: 'admitted_styles',
      isFilterable: true,
      sortingField: 'admitted',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'estDischarge',
      headerName: 'Est. Discharge',
      type: 'string',
      width: 110,
      className: 'estDischarge_styles',
      isFilterable: true,
      sortingField: 'estDischarge',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expectedMode',
      headerName: 'Expected Mode',
      type: 'string',
      width: 110,
      className: 'expectedMode_styles',
      isFilterable: true,
      sortingField: 'expectedMode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'schedule',
      headerName: 'Schedule',
      type: 'boolean',
      width: 110,
      className: 'schedule_styles',
      isFilterable: true,
      sortingField: 'schedule',
      isSortable: true,
      isLocked: false,
    },
  ],
  locationViewsColumns: [
    {
      field: 'ipAddress',
      headerName: 'IP Address',
      type: 'string',
      width: 96,
      className: 'ipAddress_styles',
      isFilterable: true,
      sortingField: 'ipAddress',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'address',
      headerName: 'Location',
      type: 'clickableString',
      width: 96,
      className: 'location_styles',
      isFilterable: false,
      sortingField: 'address',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'viewName',
      headerName: 'Screen',
      type: 'string',
      width: 145,
      className: 'viewName_styles',
      isFilterable: true,
      sortingField: 'viewName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'record',
      headerName: 'Record',
      type: 'string',
      width: 110,
      className: 'record_styles',
      isFilterable: true,
      sortingField: 'record',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'timestamp',
      headerName: 'Time',
      type: 'string',
      width: 96,
      className: 'time_styles',
      isFilterable: true,
      sortingField: 'timestamp',
      isSortable: true,
      isLocked: false,
    },
  ],
  servicesColumns: [
    {
      field: 'serviceCategory',
      headerName: 'Service Category',
      type: 'string',
      flex: 1,
      className: 'serviceCategory_styles',
      isFilterable: true,
      sortingField: 'serviceCategory',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'serviceType',
      headerName: 'Service Type',
      type: 'string',
      flex: 1,
      className: 'serviceType_styles',
      isFilterable: true,
      sortingField: 'serviceType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'location',
      headerName: 'Location',
      type: 'string',
      flex: 1,
      className: 'location_styles',
      isFilterable: true,
      sortingField: 'location',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  segmentNotesColumns: [
    {
      field: 'category',
      headerName: 'Note Category',
      filterKey: 'categoryId',
      filterType: 'select',
      filterSelectName: 'noteCategory',
      isFilterable: true,
      sortingField: 'categoryId',
      isSortable: true,
      flex: 1,
      className: 'noteCategory_styles',
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      filterKey: 'noteDetail',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'noteDetail',
      isSortable: true,
      flex: 1,
      className: 'noteDetail_styles',
      isLocked: false,
    },
    {
      field: 'username',
      headerName: 'Noted by',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'notedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      flex: 1,
      className: 'notedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'orderingValue',
      headerName: 'Segment Number',
      filterKey: 'orderingValue',
      filterType: 'localSelect',
      isFilterable: true,
      sortingField: 'orderingValue',
      isSortable: true,
      flex: 1,
      filterOptions: [],
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons' as const,
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  searchMemberColumns: [
    {
      field: 'memberId',
      headerName: 'Member ID',
      flex: 1,
      isFilterable: true,
      sortingField: 'memberId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'fullName',
      headerName: 'Name',
      flex: 1,
      isFilterable: true,
      sortingField: 'fullName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'dob',
      headerName: 'Date of Birth',
      flex: 1,
      isFilterable: true,
      sortingField: 'dob',
      isSortable: true,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'primaryContactNumber',
      headerName: 'Contact Number',
      flex: 1,
      isFilterable: true,
      sortingField: 'primaryContactNumber',
      isSortable: true,
      className: 'phone_styles',
      isLocked: false,
    },
    {
      field: 'originAddress',
      headerName: 'Mailing Address',
      flex: 1,
      isFilterable: true,
      sortingField: 'originAddress',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'view',
      headerName: 'View',
      flex: 1,
      isFilterable: true,
      sortingField: 'view',
      isSortable: true,
      className: 'viewImage_styles',
      isLocked: true,
    },
  ],
  searchRideColumns: [
    {
      field: 'serviceDate',
      headerName: 'DOS',
      flex: 1,
      isFilterable: true,
      sortingField: 'serviceDate',
      isSortable: true,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'memberId',
      headerName: 'Member ID',
      flex: 1,
      isFilterable: true,
      sortingField: 'memberId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      isFilterable: true,
      sortingField: 'name',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'confirmationCode',
      headerName: 'Confirmation',
      flex: 1,
      isFilterable: true,
      sortingField: 'confirmationCode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'rideStatus',
      headerName: 'Ride Status',
      flex: 1,
      isFilterable: false,
      sortingField: 'rideStatus',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'originAddress',
      headerName: 'Origin Location Address',
      flex: 1,
      isFilterable: true,
      sortingField: 'originAddress',
      isSortable: true,
      className: 'search_location_styles',
      isLocked: false,
    },
    {
      field: 'view',
      headerName: 'View',
      flex: 1,
      isFilterable: true,
      sortingField: 'view',
      isSortable: true,
      className: 'viewImage_styles',
      isLocked: true,
    },
  ],
  searchContractorColumns: [
    {
      field: 'contractorName',
      headerName: 'Contractor Name',
      flex: 1,
      isFilterable: true,
      sortingField: 'contractorName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      type: 'status',
      isPillDisabled: true,
      isLocked: false,
    },
    {
      field: 'state',
      headerName: 'State',
      flex: 1,
      isFilterable: true,
      sortingField: 'state',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'dispatchPlatform',
      headerName: 'ATMS Software',
      flex: 1,
      isFilterable: true,
      sortingField: 'dispatchPlatform',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'primaryContactNumber',
      headerName: 'Contact Record',
      flex: 1,
      isFilterable: true,
      sortingField: 'primaryContactNumber',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'originAddress',
      headerName: 'Address',
      flex: 1,
      isFilterable: true,
      sortingField: 'originAddress',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'view',
      headerName: 'View',
      flex: 1,
      isFilterable: false,
      sortingField: 'view',
      isSortable: false,
      className: 'viewImage_styles',
      isLocked: true,
    },
  ],
  searchSOColumns: [
    {
      field: 'startDate',
      headerName: 'Start Date',
      flex: 1,
      isFilterable: true,
      sortingField: 'startDate',
      isSortable: true,
      className: 'date_styles',
      isLocked: false,
    },
    {
      field: 'days',
      headerName: 'Days',
      flex: 1,
      isFilterable: true,
      sortingField: 'days',
      isSortable: true,
      className: 'days_styles',
      isLocked: false,
    },

    {
      field: 'memberId',
      headerName: 'Member ID',
      flex: 1,
      isFilterable: true,
      sortingField: 'memberId',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      isFilterable: true,
      sortingField: 'name',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'confirmationCode',
      headerName: 'Confirmation',
      flex: 1,
      isFilterable: true,
      sortingField: 'confirmationCode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'originAddress',
      headerName: 'Origin Location Address',
      flex: 1,
      isFilterable: true,
      sortingField: 'originAddress',
      isSortable: true,
      className: 'search_location_styles',
      isLocked: false,
    },
    {
      field: 'view',
      headerName: 'View',
      flex: 1,
      isFilterable: false,
      sortingField: 'view',
      isSortable: false,
      className: 'viewImage_styles',
      isLocked: false,
    },
  ],
  surveyTemplateColumns: [
    {
      field: 'templateName',
      headerName: 'Template name',
      type: 'string',
      width: 135,
      className: 'templateName_styles',
      isFilterable: true,
      sortingField: 'templateName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'description',
      headerName: 'Description',
      type: 'string',
      width: 138,
      className: 'description_styles',
      isFilterable: true,
      sortingField: 'description',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  surveysColumns: [
    {
      field: 'sendingDate',
      headerName: 'Sent',
      type: 'string',
      flex: 1,
      className: 'sent_styles',
      isFilterable: true,
      sortingField: 'sendingDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'sendTo',
      headerName: 'Sent to',
      type: 'string',
      flex: 1,
      className: 'sentTo_styles',
      isFilterable: true,
      sortingField: 'sendTo',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'template',
      headerName: 'Survey Name',
      type: 'string',
      flex: 1,
      className: 'surveyName_styles',
      isFilterable: true,
      sortingField: 'template',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'signed',
      headerName: 'Signed',
      type: 'boolean',
      flex: 1,
      className: 'signed_styles',
      isFilterable: true,
      sortingField: 'signed',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  permissionsTableColumns: [
    {
      field: 'module',
      headerName: 'Module',
      type: 'string',
      isFilterable: true,
      filterType: 'text',
      filterKey: 'module',
      isLocked: false,
    },
    {
      field: 'tab',
      headerName: 'Tab',
      type: 'string',
      isFilterable: true,
      filterType: 'text',
      filterKey: 'name',
      isLocked: false,
    },
    {
      field: 'read',
      headerName: 'View',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'document',
      headerName: '',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
    //TODO this part is deleted from permissions table
    // {
    //   field: 'special',
    //   headerName: 'Special',
    //   type: 'boolean',
    //   isFilterable: false,
    // },
    {
      field: 'audit',
      headerName: '',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'create',
      headerName: '',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'edit',
      headerName: 'Edit',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'noAccess',
      headerName: 'No Access',
      type: 'boolean',
      isFilterable: false,
      isLocked: false,
    },
  ],
  userViewsColumns: [
    {
      field: 'ipAddress',
      headerName: 'IP Address',
      filterKey: 'ipAddress',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'ipAddress',
      isSortable: true,
      type: 'string',
      width: 96,
      className: 'ipAddress_styles',
      isLocked: false,
    },
    {
      field: 'address',
      headerName: 'Location',
      // filterKey: 'city',
      filterKey: 'address',
      filterType: 'text',
      isFilterable: true,
      // sortingField: 'city',
      sortingField: 'address',
      isSortable: true,
      type: 'clickableString',
      width: 96,
      className: 'location_styles',
      isLocked: false,
    },
    {
      field: 'viewName',
      headerName: 'Screen',
      filterKey: 'viewName',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'viewName',
      isSortable: true,
      type: 'string',
      width: 145,
      className: 'viewName_styles',
      isLocked: false,
    },
    {
      field: 'resource',
      headerName: 'Record',
      filterKey: 'resource',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'resource',
      isSortable: true,
      type: 'clickableString',
      width: 110,
      className: 'record_styles',
      isLocked: false,
    },
    {
      field: 'timestamp',
      headerName: 'Time',
      filterKey: 'timestamp',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'timestamp',
      isSortable: true,
      type: 'string',
      width: 96,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  userLoginsColumns: [
    {
      field: 'ipAddress',
      headerName: 'IP Address',
      filterKey: 'ipAddress',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'ipAddress',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'ipAddress_styles',
      isLocked: false,
    },
    {
      field: 'location',
      headerName: 'Location',
      // filterKey: 'city',
      filterKey: 'address',
      filterType: 'text',
      isFilterable: true,
      // sortingField: 'city',
      sortingField: 'address',
      isSortable: true,
      type: 'clickableString',
      flex: 1,
      className: 'location_styles',
      isLocked: false,
    },
    {
      field: 'timestamp',
      headerName: 'Time',
      filterKey: 'timestamp',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'timestamp',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  userActivityColumns: [
    {
      field: 'resource',
      headerName: 'Table',
      filterKey: 'resource',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'resource',
      isSortable: true,
      type: 'string',
      width: 96,
      className: 'resourceTable_styles',
      isLocked: false,
    },
    {
      field: 'record',
      headerName: 'Record',
      filterKey: 'record',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'record',
      isSortable: true,
      type: 'clickableString',
      width: 96,
      className: 'recordId_styles',
      isLocked: false,
    },
    {
      field: 'field',
      headerName: 'Field',
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'field',
      isSortable: true,
      type: 'string',
      width: 96,
      className: 'field_style',
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'beforeChange',
      isSortable: true,
      type: 'string',
      width: 110,
      className: 'beforeChange_style',
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'afterChange',
      isSortable: true,
      type: 'string',
      width: 145,
      className: 'afterChange_style',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Changed ',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      type: 'string',
      width: 110,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  userAuditColumns: [
    {
      field: 'field',
      headerName: 'Field',
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'field',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'field_styles',
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'beforeChange',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'originalValue_styles',
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'afterChange',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'newValue_styles',
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'Changed By',
      filterKey: 'userId',
      filterType: 'select',
      filterSelectName: 'changedBy',
      isFilterable: true,
      sortingField: 'userId',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'changedBy_styles',
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      filterKey: 'roleId',
      filterType: 'select',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      type: 'string',
      flex: 1,
      className: 'role_styles',
      isLocked: false,
    },
    {
      field: 'actionTime',
      headerName: 'Time',
      filterKey: 'actionTime',
      filterType: 'date',
      isFilterable: true,
      sortingField: 'actionTime',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: 'time_styles',
      isLocked: false,
    },
  ],
  usersTableColumns: [
    {
      field: 'nameForTable',
      headerName: 'Name',
      type: 'avatar',
      flex: 1,
      isFilterable: true,
      sortingField: 'firstName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'typeForTable',
      headerName: 'Type',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: 'roleType',
      isSortable: true,
      className: 'type_styles__admin',
      isLocked: false,
    },
    {
      field: 'active',
      headerName: 'Status',
      type: 'status',
      flex: 1,
      isFilterable: true,
      sortingField: 'active',
      isSortable: true,
      className: 'table_status_styles',
      isLocked: false,
    },
  ],
  usersTableFiltrationColumns: [
    {
      field: 'firstName',
      headerName: 'First Name',
      filterKey: 'firstName',
      filterType: 'text',
      isFilterable: true,
      type: 'avatar',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      filterKey: 'lastName',
      filterType: 'text',
      isFilterable: true,
      type: 'avatar',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'email',
      headerName: 'Email',
      filterKey: 'email',
      filterType: 'text',
      isFilterable: true,
      type: 'avatar',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      filterKey: 'typeId',
      filterType: 'select',
      filterSelectName: 'userPermissions',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'active',
      headerName: 'Status',
      filterKey: 'active',
      filterType: 'boolean',
      isFilterable: true,
      type: 'status',
      flex: 1,
      isLocked: false,
    },
  ],
  usersRolesTableColumns: [
    {
      field: 'nameForTable',
      headerName: 'Name',
      type: 'avatar',
      flex: 1,
      isFilterable: true,
      sortingField: 'firstName',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'typeForTable',
      headerName: 'Type',
      type: 'string',
      flex: 1,
      isFilterable: true,
      sortingField: '',
      isSortable: false,
      className: 'type_styles',
      isLocked: false,
    },
  ],
  personnelIdentificationColumns: [
    {
      field: 'number',
      headerName: 'ID#',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Issued',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'issuing',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'issuing_styles',
      isFilterable: true,
      sortingField: 'issuing',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'ID Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  personnelCertificationColumns: [
    {
      field: 'number',
      headerName: 'ID#',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Issued',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'organization',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'organization_styles',
      isFilterable: true,
      sortingField: 'organization',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'ID Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  personnelScreeningColumns: [
    {
      field: 'number',
      headerName: 'ID#',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Issued',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'organization',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'organization_styles',
      isFilterable: true,
      sortingField: 'organization',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'ID Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  personnelPermitColumns: [
    {
      field: 'number',
      headerName: 'ID#',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Issued',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'organization',
      headerName: 'Issued by',
      type: 'string',
      flex: 1,
      className: 'organization_styles',
      isFilterable: true,
      sortingField: 'organization',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'ID Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  personnelServiceDatesColumns: [
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'note',
      headerName: 'Detail',
      type: 'string',
      flex: 1,
      className: 'note_styles',
      isFilterable: true,
      sortingField: 'note',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  rideLocationColumns: [
    {
      field: 'dragHandleIcon',
      headerName: '',
      type: 'drag',
      flex: 1,
      isFilterable: false,
      isLocked: true,
    },
    {
      field: 'pickupLocations',
      headerName: 'Location and Status',
      type: 'location',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'scheduledPickupTime',
      headerName: 'Pickup Time',
      type: 'time',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
  ],
  rideTableColumns: [
    {
      field: 'num',
      headerName: 'Sequence',
      isFilterable: false,
      isSortable: false,
      type: 'string',
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'scheduledPickupTime',
      headerName: 'Pickup',
      filterKey: 'scheduledPickupTime',
      filterType: 'time',
      isFilterable: true,
      isSortable: false,
      type: 'string',
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'scheduledAppointmentTime',
      headerName: 'Drop-Off',
      filterKey: 'scheduledAppointmentTime',
      filterType: 'time',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'pickUpContactPhone',
      headerName: 'Phone',
      filterKey: 'pickUpContactPhone',
      filterType: 'text',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'authorization',
      headerName: 'Service',
      filterKey: 'authorizationId',
      filterType: 'select',
      filterSelectName: 'rideCategoryTypes',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'pickupLocations.address1',
      headerName: 'Pickup Address',
      filterKey: 'pickupLocations.address1',
      filterType: 'text',
      type: 'string',
      isFilterable: false,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'contractor',
      headerName: 'Contractor',
      filterKey: 'contractorId',
      filterType: 'select',
      filterSelectName: 'rideContractor',
      type: 'string',
      isFilterable: false,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      filterKey: 'statusId',
      filterType: 'select',
      filterSelectName: 'rideStatus',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'rideOrderConfirmationCode',
      headerName: 'Ride order code',
      filterKey: 'rideOrderConfirmationCode',
      filterType: 'text',
      filterSelectName: 'rideOrderConfirmationCode',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isHideColumn: true,
      isLocked: false,
    },
    {
      field: 'rideRequestDate',
      headerName: 'Date of service',
      filterKey: 'rideRequestDate',
      filterType: 'date',
      type: 'date',
      isFilterable: true,
      isSortable: false,
      isHideColumn: true,
      isLocked: false,
    },
  ],
  standingOrderTableColumns: [
    {
      field: 'num',
      headerName: 'Sequence',
      isFilterable: false,
      isSortable: false,
      type: 'string',
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'scheduledPickupTime',
      headerName: 'Pickup',
      filterKey: 'scheduledPickupTime',
      filterType: 'time',
      isFilterable: true,
      isSortable: false,
      type: 'string',
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'scheduledAppointmentTime',
      headerName: 'Drop-Off',
      filterKey: 'scheduledAppointmentTime',
      filterType: 'time',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'pickUpContactPhone',
      headerName: 'Phone',
      filterKey: 'pickUpContactPhone',
      filterType: 'text',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'authorization',
      headerName: 'Service',
      filterKey: 'authorizationId',
      filterType: 'select',
      filterSelectName: 'rideCategoryTypes',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'pickupLocations.address1',
      headerName: 'Pickup Address',
      filterKey: 'pickupLocations.address1',
      filterType: 'text',
      type: 'string',
      isFilterable: false,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'contractor',
      headerName: 'Contractor',
      filterKey: 'contractorId',
      filterType: 'select',
      filterSelectName: 'rideContractor',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'payerName',
      headerName: 'Payer',
      filterKey: 'payerName',
      filterType: 'text',
      filterSelectName: 'payerName',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: true,
    },
    {
      field: 'status',
      headerName: 'Status',
      filterKey: 'statusId',
      filterType: 'select',
      filterSelectName: 'rideStatus',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
      isHideColumn: false,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      filterKey: 'startDate',
      filterType: 'date',
      filterSelectName: 'startDate',
      type: 'date',
      isFilterable: true,
      isSortable: false,
      isHideColumn: true,
      isLocked: false,
    },
    {
      field: 'rideOrderConfirmationCode',
      headerName: 'Standing Order Ride Code',
      filterKey: 'rideOrderConfirmationCode',
      filterType: 'text',
      filterSelectName: 'rideOrderConfirmationCode',
      type: 'string',
      isFilterable: true,
      isSortable: false,
      isHideColumn: true,
      isLocked: false,
    },
  ],
  contactsTableColumns: [
    {
      field: 'nameForTable',
      sortingField: 'firstName',
      isSortable: true,
      headerName: 'Name',
      type: 'avatar',
      flex: 1,
      isFilterable: true,
      isLocked: false,
    },
    {
      field: 'typeForTable',
      sortingField: 'type',
      isSortable: true,
      headerName: 'Type',
      type: 'string',
      flex: 1,
      isFilterable: true,
      className: 'type_styles',
      isLocked: false,
    },
    {
      field: 'statusForTable',
      sortingField: 'activeIndicator',
      isSortable: false,
      headerName: 'Status',
      type: 'status',
      flex: 1,
      isFilterable: false,
      className: 'table_status_styles',
      isLocked: false,
    },
  ],
  contactsTableFiltrationColumns: [
    {
      field: 'firstName',
      headerName: 'First Name',
      filterKey: 'firstName',
      filterType: 'text',
      isFilterable: true,
      type: 'avatar',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      filterKey: 'lastName',
      filterType: 'text',
      isFilterable: true,
      type: 'avatar',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'relation',
      headerName: 'Relation',
      filterKey: 'relationId',
      filterType: 'select',
      filterSelectName: 'contactRelation',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'Type',
      filterKey: 'type',
      filterType: 'text',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'activeIndicator',
      headerName: 'Status',
      filterKey: 'activeIndicator',
      filterType: 'boolean',
      isFilterable: true,
      type: 'status',
      flex: 1,
      isLocked: false,
    },
  ],
  notificationContactsTableColumns: [
    {
      field: 'contactName',
      sortingField: 'contactName',
      isSortable: false,
      headerName: 'Contact Name',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'notificationMethod',
      sortingField: 'notificationMethod',
      isSortable: false,
      headerName: 'Notification Method',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'emailAddress',
      isSortable: false,
      headerName: 'Email Address',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'mobilePhoneNumber',
      isSortable: false,
      headerName: 'Mobile Phone Number',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'notificationFrequencyMinutes',
      isSortable: false,
      headerName: 'Notification Frequency (minutes)',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: false,
        delete: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  notificationContactsTableFiltrationColumns: [
    {
      field: 'contactName',
      headerName: 'Contact Name',
      filterKey: 'contactName',
      filterType: 'text',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'notificationMethod',
      headerName: 'Notification Method',
      filterKey: 'notificationMethod',
      filterType: 'select',
      filterSelectName: 'notificationMethod',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'emailAddress',
      headerName: 'Email Address',
      filterKey: 'emailAddress',
      filterType: 'text',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
    {
      field: 'mobilePhoneNumber',
      headerName: 'Mobile Phone Number',
      filterKey: 'mobilePhoneNumber',
      filterType: 'text',
      isFilterable: true,
      type: 'string',
      flex: 1,
      isLocked: false,
    },
  ],
  businessOwnershipColumns: [
    {
      field: 'name',
      headerName: 'Owner/Entity Name',
      type: 'string',
      flex: 1,
      className: 'name_styles',
      isFilterable: true,
      sortingField: 'name',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'title',
      headerName: 'Role/Title',
      type: 'string',
      flex: 1,
      className: 'title_styles',
      isFilterable: true,
      sortingField: 'title',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'ownership',
      headerName: 'Ownership %',
      type: 'string',
      flex: 1,
      className: 'ownership_styles',
      isFilterable: true,
      sortingField: 'ownership',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  companyLicensesColumns: [
    {
      field: 'number',
      headerName: 'Identification Number',
      type: 'string',
      flex: 1,
      className: 'number_styles',
      isFilterable: true,
      sortingField: 'number',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'type',
      headerName: 'License Type',
      type: 'string',
      flex: 1,
      className: 'type_styles',
      isFilterable: true,
      sortingField: 'type',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'issuing',
      headerName: 'Issuing Authority',
      type: 'string',
      flex: 1,
      className: 'issuing_styles',
      isFilterable: true,
      sortingField: 'issuing',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'name',
      headerName: 'Nature of Business',
      type: 'boolean',
      flex: 1,
      className: 'name_styles',
      isFilterable: true,
      sortingField: 'name',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'viewImage',
      headerName: 'View',
      width: 100,
      isSortable: false,
      renderCell: (params) => (
        <button onClick={() => {}} className={'my-data-grid-button'}>
          {params?.value ? <EyeIcon toggle={true} /> : <ForbiddenIcon />}
        </button>
      ),
      className: 'viewImage_styles',
      isFilterable: false,
      isLocked: true,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  coverageAreaColumns: [
    {
      field: 'state',
      headerName: 'State',
      type: 'string',
      flex: 1,
      filterKey: 'state',
      filterType: 'text',
      className: '',
      isFilterable: true,
      sortingField: 'state',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'county',
      headerName: 'County',
      type: 'string',
      flex: 1,
      className: '',
      filterKey: 'county',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'county',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'city',
      headerName: 'City',
      type: 'string',
      flex: 1,
      className: '',
      filterKey: 'city',
      filterType: 'text',
      isFilterable: true,
      sortingField: 'city',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'zipCode',
      headerName: 'Zip Code',
      type: 'string',
      flex: 1,
      filterKey: 'zipCode',
      filterType: 'text',
      className: '',
      isFilterable: true,
      sortingField: 'zipCode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'curb',
      headerName: 'Ambulatory Curb to Curb',
      type: 'checkbox',
      width: 30,
      isSortable: false,
      className: 'curbToCurb_styles',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: 'door',
      headerName: 'Ambulatory Door to Door',
      type: 'checkbox',
      width: 30,
      isSortable: false,
      className: 'doorToDoor_styles',
      isFilterable: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  preferenceColumns: [
    {
      field: 'contractor',
      headerName: 'Contractor',
      filterKey: 'contractor',
      filterType: 'select',
      filterSelectName: 'preferContractor',
      isFilterable: true,
      sortingField: 'contractor',
      isSortable: true,
      type: 'string',
      flex: 1,
      className: '',
      isLocked: false,
    },
    {
      field: 'assignmentType',
      headerName: 'Assignment Type',
      type: 'string',
      filterType: 'select',
      flex: 1,
      className: '',
      filterKey: 'assignmentTypeId',
      isFilterable: true,
      sortingField: 'assignmentType',
      filterSelectName: 'preferAssignmentType',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      filterType: 'select',
      flex: 1,
      className: '',
      filterKey: 'statusId',
      isFilterable: true,
      sortingField: 'status',
      filterSelectName: 'activityStatus',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      type: 'string',
      filterType: 'select',
      flex: 1,
      className: '',
      filterKey: 'createdBy',
      isFilterable: true,
      sortingField: 'createdBy',
      filterSelectName: 'createdBy',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      className: '',
      filterKey: 'roleId',
      filterSelectName: 'userRole',
      isFilterable: false,
      sortingField: 'roleId',
      isSortable: false,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  qualityIncidentsColumns: [
    {
      field: 'sent',
      headerName: 'Case Number',
      type: 'string',
      flex: 1,
      className: 'sent_styles',
      isFilterable: true,
      sortingField: 'sent',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Case Type',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'effectiveDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Complainant',
      type: 'string',
      flex: 1,
      className: 'date_styles',
      isFilterable: true,
      sortingField: 'expirationDate',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'sent_to',
      headerName: 'Against',
      type: 'string',
      flex: 1,
      className: 'sentTo_styles',
      isFilterable: true,
      sortingField: 'sent_to',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      className: 'status_styles',
      isFilterable: true,
      sortingField: 'status',
      isSortable: true,
      isLocked: false,
    },
    {
      field: 'prescribed_pode',
      headerName: 'Created',
      type: 'string',
      flex: 1,
      className: 'created_styles',
      isFilterable: true,
      sortingField: 'prescribed_pode',
      isSortable: true,
      isLocked: false,
    },
    {
      field: '',
      headerName: '',
      type: 'buttons',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 30,
      isSortable: false,
      className: 'table_buttons_styles',
      isFilterable: false,
      isLocked: true,
    },
  ],
  assignmentHistoryColumns: [
    {
      field: 'member',
      headerName: 'Member',
      width: '130px',
      className: '',
      isFilterable: true,
      sortingField: 'member',
      isSortable: true,
      isChecked: true,
      isLocked: false,
    },
    {
      field: 'service',
      headerName: 'Rendering Service',
      width: '105px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'service',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'pickUpTime',
      headerName: 'PU Time',
      width: '84px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'pickUpTime',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'pickUpCounty',
      headerName: 'PU County',
      width: '105px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'pickUpCounty',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'pickUpCityZipcode',
      headerName: 'PU City, Zip',
      width: '130px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'pickUpCityZipcode',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'dropOfCityZipcode',
      headerName: 'DO City, Zip',
      width: '130px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'dropOfCityZipcode',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'miles',
      headerName: 'Miles',
      width: '68px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'miles',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'duration',
      headerName: 'Duration',
      width: '68px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'duration',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'rideOrderConfirmationCode',
      headerName: 'Ride ID',
      width: '112px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'rideOrderConfirmationCode',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'standingOrder',
      headerName: 'ST',
      width: '54px',
      type: 'disabledRadio',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'st',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'assignmentStatus',
      headerName: 'Assign Status',
      width: '160px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'assignmentStatus',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'running',
      headerName: 'Running',
      width: '92px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'running',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'los',
      headerName: 'LOS',
      width: '84px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'los',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'username',
      headerName: 'User',
      width: '84px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'username',
      isChecked: true,
      isSortable: true,
    },
    {
      field: 'dos',
      headerName: 'Datetime',
      width: '140px',
      isFilterable: true,
      isLocked: false,
      className: '',
      sortingField: 'dos',
      isChecked: true,
      isSortable: true,
    },

    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: true,
        audit: true,
      },
      width: 40,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
    },
  ],
  assignmentLockColumns: [
    {
      field: 'lockStatus',
      headerName: 'Status',
      width: '56px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'lockStatus',
      isSortable: true,
    },
    {
      field: 'desc',
      headerName: 'Desc',
      width: '88px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'desc',
      isSortable: true,
    },
    {
      field: 'acc',
      headerName: 'ACC',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'acc',
      isSortable: true,
    },
    {
      field: 'add',
      headerName: 'ADD',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'add',
      isSortable: true,
    },
    {
      field: 'wc',
      headerName: 'WC',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'wc',
      isSortable: true,
    },
    {
      field: 'gur',
      headerName: 'GUR',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'gur',
      isSortable: true,
    },
    {
      field: 'bls',
      headerName: 'BLS',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'bls',
      isSortable: true,
    },
    {
      field: 'als',
      headerName: 'ALS',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'als',
      isSortable: true,
    },
    {
      field: 'sct',
      headerName: 'SCT',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'sct',
      isSortable: true,
    },
    {
      field: 'fw',
      headerName: 'FW',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'fw',
      isSortable: true,
    },
    {
      field: 'rw',
      headerName: 'RW',
      width: '44px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'rw',
      isSortable: true,
    },
    {
      field: 'total',
      headerName: 'Total',
      width: '56px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'total',
      isSortable: true,
    },
    {
      field: 'demand',
      headerName: 'Demand',
      width: '72px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'demand',
      isSortable: true,
    },
    {
      field: 'standing',
      headerName: 'Standing Order',
      width: '82px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'standing',
      isSortable: true,
    },
    {
      field: 'dateTime',
      headerName: 'DateTime',
      width: '156px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'dateTime',
      isSortable: true,
    },
    {
      field: 'user',
      headerName: 'User',
      width: '120px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'user',
      isSortable: true,
    },
    {
      field: 'userRole',
      headerName: 'User Role',
      width: '120px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'userRole',
      isSortable: true,
    },
    {
      field: 'download',
      headerName: 'Download',
      width: '92px',
      isFilterable: false,
      isLocked: true,
      className: '',
      sortingField: 'download',
      isSortable: true,
    },
    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: false,
        audit: false,
      },
      width: 40,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
      isEmpty: true,
    },
  ],
  transmitHistoryColumns: [
    {
      field: 'sentTo',
      headerName: 'Sent To',
      width: '150px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'sentTo',
      isSortable: true,
    },
    {
      field: 'newRecord',
      headerName: 'N',
      width: '48px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'newRecord',
      isSortable: true,
      renderCell: () => <TooltipWrapper tooltip="New">N</TooltipWrapper>,
    },
    {
      field: 'modifiedRecord',
      headerName: 'M',
      width: '48px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'modifiedRecord',
      isSortable: true,
      renderCell: () => <TooltipWrapper tooltip="Modified">M</TooltipWrapper>,
    },
    {
      field: 'transmittedRecord',
      headerName: 'T',
      width: '48px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'transmittedRecord',
      isSortable: true,
      renderCell: () => (
        <TooltipWrapper tooltip="Transmitted">T</TooltipWrapper>
      ),
    },
    {
      field: 'errorRecord',
      headerName: 'E',
      width: '48px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'errorRecord',
      isSortable: true,
      renderCell: () => <TooltipWrapper tooltip="Error">E</TooltipWrapper>,
    },
    {
      field: 'totalRecords',
      headerName: 'Total',
      width: '64px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'totalRecords',
      isSortable: true,
    },
    {
      field: 'transmitType',
      headerName: 'Transmit Type',
      width: '132px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'transmitType',
      isSortable: true,
    },
    {
      field: 'fileId',
      headerName: 'File ID',
      width: '96px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'fileId',
      isSortable: true,
    },
    {
      field: 'transmitStatus',
      headerName: 'Transmit Status',
      width: '136px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'transmitStatus',
      isSortable: true,
    },
    {
      field: 'error',
      headerName: 'Error',
      width: '128px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'error',
      isSortable: true,
    },
    {
      field: 'dateTime',
      headerName: 'DateTime',
      width: '152px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'dateTime',
      isSortable: true,
    },
    {
      field: 'userName',
      headerName: 'User',
      width: '120px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'user',
      isSortable: true,
    },
    {
      field: 'userRole',
      headerName: 'User Role',
      width: '120px',
      isFilterable: false,
      isLocked: false,
      className: '',
      sortingField: 'userRole',
      isSortable: true,
    },
    {
      field: 'download',
      headerName: 'Download',
      width: '92px',
      isFilterable: false,
      isLocked: true,
      className: '',
      sortingField: 'download',
      isSortable: false,
    },
    {
      field: '',
      headerName: 'checkboxes',
      type: 'buttons',
      className: 'table_checkbox_options',
      buttons: {
        view: false,
        edit: false,
        audit: false,
      },
      width: 40,
      isSortable: false,
      isFilterable: false,
      isChecked: true,
      isLocked: true,
      isEmpty: true,
    },
  ],
  credentialingVehicleListColumns: [
    {
      field: 'issuedNumber',
      headerName: 'Vehicle Number',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'vehicleType',
      headerName: 'Vehicle Type',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'makeModelYear',
      headerName: 'Make / Model / Year',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'plate',
      headerName: 'License Plate Number',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'vehicleStatus',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
      // the custom table hands renderCell the row itself, not { row }
      renderCell: (row: any) => (
        <span
          className={`credentialing__badge credentialing__badge--${(
            row?.vehicleStatus ?? ''
          )
            .toLowerCase()
            .replace(/\s+/g, '-')}`}
        >
          {row?.vehicleStatus}
        </span>
      ),
    },
    {
      field: 'compliantAt',
      headerName: 'Compliant At',
      type: 'string',
      flex: 1,
      isFilterable: false,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'view',
      headerName: 'View',
      className: 'viewImage_styles',
      isFilterable: false,
      isSortable: false,
      isLocked: true,
    },
  ],
  credentialingVehicleRegistrationColumns: [
    {
      field: 'registrationNumber',
      headerName: 'Registration Number',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'registrationClass',
      headerName: 'Class',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'registrationStatus',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'plate',
      headerName: 'License Plate',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'state',
      headerName: 'State',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'inspectedDate',
      headerName: 'Issue Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    credentialingValidityColumn,
    credentialingApprovalColumn,
    credentialingRowMenuColumn,
  ],
  credentialingVehicleInspectionColumns: [
    {
      field: 'type',
      headerName: 'Type',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'result',
      headerName: 'Result',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'inspectedDate',
      headerName: 'Inspection Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'provider',
      headerName: 'Provider',
      type: 'string',
      flex: 1,
      isFilterable: true,
      filterType: 'text',
      isSortable: false,
      isLocked: false,
    },
    credentialingValidityColumn,
    // the Approval pills and the Edit / Audit menu come with the tab, see
    // VehicleInspection
  ],
  credentialingVehiclePermitColumns: [
    {
      field: 'permitType',
      headerName: 'Permit Type',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'issuing',
      headerName: 'Issuing Authority',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'permitStatus',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Issue Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'expiration',
      headerName: 'Expiration Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
  ],
  credentialingVehicleServiceDatesColumns: [
    {
      field: 'serviceType',
      headerName: 'Service Type',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'serviceProvider',
      headerName: 'Service Provider',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'serviceStatus',
      headerName: 'Status',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Service Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'mileage',
      headerName: 'Mileage',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
  ],
  credentialingPayerComplianceColumns: [
    {
      field: 'payerName',
      headerName: 'Payer Name',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'payerId',
      headerName: 'Payer ID',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'complianceStatus',
      headerName: 'Compliance Status',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'effectiveDate',
      headerName: 'Effective Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration Date',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
  ],
  credentialingNotesColumns: [
    {
      field: 'noteCategory',
      headerName: 'Note Category',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'noteDetail',
      headerName: 'Note Detail',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'notedBy',
      headerName: 'Noted By',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'time',
      headerName: 'Time',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
  ],
  // the design's order: when, who, then what changed
  credentialingAuditLogColumns: [
    {
      field: 'actionTime',
      headerName: 'Date & Time',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'userName',
      headerName: 'User',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'field',
      headerName: 'Field',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
      renderCell: (row: any) => row?.beforeChange || '—',
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
      renderCell: (row: any) => row?.afterChange || '—',
      filterKey: 'actionTime',
      filterType: 'date',
    },
    {
      field: 'userName',
      headerName: 'User',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'role',
      headerName: 'Role',
      type: 'string',
      flex: 1,
      isFilterable: false,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'field',
      headerName: 'Field',
      type: 'string',
      flex: 1,
      filterKey: 'field',
      filterType: 'text',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'beforeChange',
      headerName: 'Original Value',
      type: 'string',
      flex: 1,
      filterKey: 'beforeChange',
      filterType: 'text',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
    },
    {
      field: 'afterChange',
      headerName: 'New Value',
      type: 'string',
      flex: 1,
      filterKey: 'afterChange',
      filterType: 'text',
      isFilterable: true,
      isSortable: false,
      isLocked: false,
    },
  ],
} as const satisfies Record<string, Column[]>;

export type TableKeyType = keyof typeof TABLE_COLUMNS;
